export const DEBOUNCE_TIME = 500;
export const DETAILS_WIDTH = 520;
export const LIST_HEIGHT = 'calc(100vh - 80px)';
export const LIST_WIDTH = 600;
export const MIN_CHARS_TO_SEARCH = 2;
export const PAGE_SIZE = 20;
